import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import SideBar from "../common/SideBar";
import Program from "./program/Program.js";
import { useParams, Link, useHistory } from "react-router-dom";
import ProgramDetail from "./program/ProgramDetail";
import AuditTrail from "./program/AuditTrail";
import AssignedTable from "./program/ProgramDetailBlock/AssignedTable";
import FeaturesBenefits from "./program/FeaturesBenefits";
import { GetProgramDetailCancelToken, GetShortCourseData, getVersionData } from "../../services/ProgramService";
import { TrimText } from "../common/TrimText";
import { GlobalIconNames } from "../../utils/GlobalIconNames";
import axios from "axios";
import ShortCourse from "./ShortCourses/ShortCourse.js";
import ShortCourseDetails from "./ShortCourses/ShortCourseDetails.js";
import ProgrammeDate from "./program/ProgrammeDate";
import CourseDates from "./ShortCourses/CourseDates.js";
import ShortCourseOutcomes from "./ShortCourses/ShortCourseOutcomes";
import ShortCourseTopics from "./ShortCourses/ShortCourseTopics";
import ShortCourseFeaturesBenefits from "./ShortCourses/ShortCourseFeaturesBenefits";

import StudyPath from "./program/StudyPath.js";
import StudyPathRearrange from "./program/StudyPathRearrange.js";
import CreateStudyPath from "./program/CreateStudyPath"
import GraduatesTable from "./program/GraduatesTable.js";
import PermissionsGate from "../../utils/permissionGate.js";
import Swal from "sweetalert2";
import SoftwareUsed from "./program/SoftwareUsed.js";
import Resources from "./program/Resources.js";
import ShortCourseResources from "./ShortCourses/ShortCourseResources.js";
import VersionTable from "./program/ProgramDetailBlock/VersionTable.js";
import VersionPageData from "./program/ProgramDetailBlock/VersionPageData.js";
import { useLocation } from "react-router-dom";
import ProgrameGradeSetting from "../courses/Programs/ProgrameGradeSetting.js";
import PMCGradeBook from "./program/ProgramDetailBlock/PMCGradeBook.js";
import LinkedProgrammes from "./program/LinkedProgrammes.js";

const Programs = () => {
  const history = useHistory();
  const { tab, type, id } = useParams();
  const [programId] = useState(id);
  const [programName, setProgrammeName] = useState("");
  const [detail, setDetail] = useState([]);
  const [QAview, setQAview] = useState(false);
  const [refresh, setRefresh] = useState(Date.now());
  const cancelTokenSources = useRef([]);

  // version's state
  const [versionData, setVersionData] = useState([]);
  const [vDataloading, setVDataLoading] = useState(false);

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const queryVersionId = query.get("versionId");
  const queryProgrammeId = query.get("programmeId");
  const queryType = query.get("type");

  // Redirect if PMC Not linked and trying to access versions tab when version feature is disabled
  useEffect(() => {
    if (Object.keys(detail).length > 0 && tab && Number(detail?.EnableStudypathLinkReReg) !== 1) {
      const tempTabNotAllowedList = ['versions'];
      if (tempTabNotAllowedList.includes(tab)) {
        history.push(`/program-management-center/programmes/programme/open/${queryProgrammeId ?? id}`);
      }
    }
  }, [detail, tab]);

  useEffect(() => {
    const cancelTokenSources = [];
    const programmeDetails = async () => {

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const res = await GetProgramDetailCancelToken({ PMC_ID: queryProgrammeId ?? id }, source.token);
        if (res.status === 200) {
          setProgrammeName(res.data[0].name);
          setDetail(res.data[0]);

          if (!res.data[0]?.Id) {
            Swal.fire({
              icon: "Info",
              title: "Info",
              text: "No record found with this id",
            })
            history.push(`/program-management-center/programmes/programme/table`)
          }
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    const shortCourseDetail = async () => {
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const res = await GetShortCourseData({ id: queryProgrammeId ?? id }, source.token);
        if (res.status === 200) {
          const respData = res.data?.result;
          setProgrammeName(respData?.name);
          setDetail(respData);
        }


      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        if (error?.response?.data?.message == "No data found") {
          Swal.fire({
            icon: "Info",
            title: "Info",
            text: "No record found with this id",
          })
          history.push(`/program-management-center/programmes/shortCourse/table`)

        }
      }
    }

    if ((tab === "shortCourse" && (type == "open" || type == "duplicate")) || ((tab == "shortCourseFeatures-benefits" || tab === "shortCourse-resources" || tab == "shortCoursetopics" || tab == "shortCourseOutcomes" || tab == "courseDates") && type == "table") || (tab == "shortCourseAuditTrail" && type == "open")) {
      shortCourseDetail();
    }

    if ((tab === "programme" && (type == "open" || type == "duplicate")) || ((tab == "features-benefits" || tab == "" || tab == "linked_programmes" || tab == "graduates" || (tab == "versions") || tab == "programmeDates" && type == "table") || tab === "resources" || (tab == "auditTrail" && type == "open"))) {
      programmeDetails();
    }

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
        setDetail([])
      });
    };
  }, [id, refresh, queryProgrammeId]);

  useEffect(() => {

    cancelTokenSources.current.forEach(source => {
      source.cancel('New version request made');
    });
    cancelTokenSources.current = [];

    const fetchVersionData = () => {
      const source = axios.CancelToken.source();
      cancelTokenSources.current.push(source);

      setVDataLoading(true)
      getVersionData({ id: queryVersionId })
        .then((res) => {
          if (!res.data?.getVersion?.id) {
            Swal.fire({
              icon: "info",
              title: "Info",
              text: "No record found with this id",
            });
            history.push(`/program-management-center/programmes/versions/table/${queryProgrammeId}`);
          } else {
            setVersionData(res.data?.getVersion)
            setProgrammeName(res.data?.getVersion?.name || "")
          }
        })
        .catch((err) => {
          if (!axios.isCancel(err)) {
            console.error(err);
          }
        })
        .finally(() => setVDataLoading(false));
    };

    if (queryVersionId && tab == "versions") {
      fetchVersionData();
    }
  }, [queryVersionId, queryProgrammeId, refresh, tab]);

  return (
    <>
      <Header></Header>
      <div className="content-wrapper d-flex flex-wrap new-standard-box">
        <SideBar></SideBar>
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            {/* <Tabs /> */}
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center ">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        {(tab == "programme" || tab == "shortCourse" || tab == "auditTrail") && type == "table" ? (
                          <>
                            Programmes & <span>Courses</span>
                          </>
                        ) : tab == "programme" ? (
                          "Programme: "
                        ) : (tab == "shortCourse" ||
                          tab == "courseDates" ||
                          tab == "shortCoursetopics" ||
                          tab == "shortCourseOutcomes" ||
                          tab == "shortCourseAuditTrail" ||
                          tab == "shortCourse-resources" ||
                          tab == "shortCourseFeatures-benefits") ? (
                          "Course: "
                        ) : (tab == "versions" && type == "create") ? (
                          <> Add <span>Version</span></>
                        ) : (tab == "versions" && (type !== "table")) ? (
                          <div className="pmc-version-header">
                            <div className="pmc-block">
                              PMC:&nbsp;
                              <span className="oneline-ellipsis">{versionData.pmc_name || ""}</span>
                            </div>

                            <div className="version-block">
                              Version:&nbsp;
                              <span className="oneline-ellipsis">{`${versionData?.name || ""}${type === "clone" ? "\u00A0(Copy)" : ""}`}</span>
                            </div>
                          </div>

                        ) : (
                          "Programme: "
                        )}
                        {(tab == "versions" && type == "table") ||
                          (tab == "programme" && type !== "table") ||
                          (tab == "shortCourse" && type !== "table") ||
                          (tab == "auditTrail" && type == "open") ||
                          tab == "shortCourseFeatures-benefits" ||
                          tab == "programme-structure" ||
                          tab == "assigned-modules" ||
                          tab == "programmeDates" ||
                          tab == "courseDates" ||
                          tab == "linked_programmes" ||
                          tab == "graduates" ||
                          tab == "softwareused" ||
                          tab == "shortCoursetopics" ||
                          tab == "features-benefits" ||
                          tab == "resources" ||
                          tab == "shortCourse-resources" ||
                          tab == "shortCourseOutcomes" ||
                          tab == "shortCourseAuditTrail" ? (
                          <span title={programName}>
                            {(tab == "programme" || tab == "shortCourse") &&
                              type == "add"
                              ? "Create New"
                              : TrimText(programName, 60)}
                          </span>
                        ) : (
                          ""
                        )}
                      </h4>
                    </div>
                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <button
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn btn-white-bordered"
                          >
                            <i className="fal fa-angle-left"></i>Back
                          </button>
                        </div>
                      </div>
                    </div>
                    {(tab == "versions" && (type !== "table" && type !== "create" && type !== "clone")) && <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <Link
                            to={`/program-management-center/programmes/programme/open/${queryProgrammeId ?? id}`}
                            title="PMC"
                            className="btn btn-white-bordered"
                          ><i className="fal fa-book"></i>PMC</Link>
                        </div>
                      </div>
                    </div>}

                    {/* hiding the button if Activate Programme Integration is off */}
                    {(detail?.version_id && Number(detail?.EnableStudypathLinkReReg) === 1 && (type !== "duplicate" && !(tab === "versions" && type !== "table"))) ? (
                      <div className="text-md-right action2-blk">
                        <div className="ticket-view-btn d-flex align-items-center">
                          <div className="add-new-ticket-bx">
                            <Link
                              to={`/program-management-center/programmes/versions/gradebook?versionId=${detail?.version_id ?? queryVersionId}&programmeId=${queryProgrammeId ?? id}`}
                              title="Go to current active versions gradebook"
                              className="btn btn-white-bordered"
                            ><i className="fal fa-graduation-cap"></i>Active Version Gradebook</Link>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {/* hiding the button if Activate Programme Integration is off */}
                  {(tab == "linked_programmes" && Number(detail?.EnableStudypathLinkReReg) === 1) && <div className="search-filter-div-right">
                    <div className=" filter-search-bar-blk">
                      <div className="add-ticket-blk button-reset dropdown-comman">
                        <div>
                          {type !== "add" && type !== "open" && <button
                            className="btn btn-primary"
                            title={
                              QAview ? "Standard View" : "QA View"
                            }
                            onClick={() => setQAview(!QAview)}
                          >
                            <i className="fal fa-eye"></i>{" "}
                            {QAview ? "Standard View" : "QA View"}
                          </button>}
                        </div>
                      </div>
                    </div>
                  </div>}
                </div>
                <div className="tabs-wrap">
                  {type !== "add" && type !== "duplicate" && type !== "clone" && (
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(
                            type == "table" &&
                              (tab == "programme" ||
                                tab == "auditTrail" ||
                                tab == "shortCourse")
                              ? "/program-management-center/programmes/programme/table"
                              : tab == "programme" || tab === "assigned-modules" || (tab == "versions" && type == "table") || tab === "features-benefits" || tab == 'softwareused' || tab == "study_path" || tab == "graduates" || tab == "linked_programmes" || tab == "programmeDates" || tab === "resources" || (tab == "auditTrail" && type == "open")
                                ? `/program-management-center/programmes/programme/open/${queryProgrammeId ?? id}`
                                : tab == "versions" ? (type == "create" ? `/program-management-center/programmes/versions/create?programmeId=${queryProgrammeId}` : type === "clone" ? `/program-management-center/programmes/versions/clone?versionId=${queryVersionId}&programmeId=${queryProgrammeId}` : `/program-management-center/programmes/versions/details?versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)
                                  : `/program-management-center/programmes/shortCourse/open/${queryProgrammeId ?? id}`
                          )
                        }
                      >
                        <Link
                          className={`nav-link ${((tab == "programme" || tab == "shortCourse") &&
                            type == "open") ||
                            (tab == "programme" && type == "table") ||
                            (tab == "versions" && (type == "create" || type == "details" || type === "clone"))
                            ? "active"
                            : ""
                            }`}
                          id="pills-tab1"
                          data-toggle="pill"
                          to={
                            type == "table" &&
                              (tab == "programme" ||
                                tab == "auditTrail" ||
                                tab == "shortCourse")
                              ? "/program-management-center/programmes/programme/table"
                              : tab == "programme" || tab === "assigned-modules" || (tab == "versions" && type == "table") || tab === "features-benefits" || tab == "study_path" || tab == "graduates" || tab == "linked_programmes" || tab == "programmeDates" || tab === "resources" || (tab == "auditTrail" && type == "open")
                                ? `/program-management-center/programmes/programme/open/${queryProgrammeId ?? id}`
                                : tab == "versions" ? (type == "create" ? `/program-management-center/programmes/versions/create?programmeId=${queryProgrammeId ?? id}` : type === "clone" ? `/program-management-center/programmes/versions/clone?versionId=${queryVersionId}&programmeId=${queryProgrammeId}` : `/program-management-center/programmes/versions/details?versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)
                                  : `/program-management-center/programmes/shortCourse/open/${queryProgrammeId ?? id}`
                          }
                          href="#pills-tab11"
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                        >
                          {(tab == "programme" ||
                            tab == "auditTrail" ||
                            tab == "shortCourse") &&
                            type == "table"
                            ? GlobalIconNames("Programmes").html
                            : GlobalIconNames("details").html}
                        </Link>
                      </li>

                      {(tab == "programme" ||
                        tab == "shortCourse" ||
                        tab == "auditTrail") &&
                        type == "table" && (
                          <li
                            className="nav-item"
                            onClick={() =>
                              history.push(
                                `/program-management-center/programmes/shortCourse/table`
                              )
                            }
                          >
                            <Link
                              className={`nav-link ${tab == "shortCourse" ? "active" : ""
                                }`}
                              id="pills-tab1"
                              data-toggle="pill"
                              to="/program-management-center/programmes/shortCourse/table"
                              href="#pills-tab11"
                              role="tab"
                              aria-controls="pills-tab11"
                              aria-selected="true"
                            >
                              {GlobalIconNames("shortcourse").html}
                            </Link>
                          </li>
                        )}

                      {(tab == "versions" && (type !== "create" && type !== "table" && type !== "clone")) && <>
                        <li
                          className="nav-item"
                          onClick={() => history.push(`/program-management-center/programmes/versions/assigned-modules?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}
                        >
                          <Link
                            className={`nav-link ${type == "assigned-modules" ? "active" : ""}`}
                            id="pills-tab3"
                            data-toggle="pill"
                            to={`/program-management-center/programmes/versions/assigned-modules?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`}
                            href="#pills-tab13"
                            role="tab"
                            aria-controls="pills-tab13"
                            aria-selected="true"
                          >
                            {GlobalIconNames("Modules").html}
                          </Link>
                        </li>
                        <li
                          className="nav-item"
                          onClick={() => history.push(`/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}
                        >
                          <Link
                            className={`nav-link ${type == "study_path" ? "active" : ""}`}
                            id="pills-tab4"
                            data-toggle="pill"
                            to={`/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`}

                            href="#pills-tab14"
                            role="tab"
                            aria-controls="pills-tab14"
                            aria-selected="true"
                          >
                            {GlobalIconNames("Study Path", "fa-route", "Study Path").html}
                          </Link>
                        </li>
                        <li className="nav-item" onClick={() => history.push(`/program-management-center/programmes/versions/gradeSetting?type=open&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}>
                          <Link
                            className={`nav-link cursor-pointer ${type === "gradeSetting" ? "active" : ""}`}
                            to={`/program-management-center/programmes/versions/gradeSetting?type=open&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`}
                          >
                            <i className="fal fa-sliders-h-square"></i>Grade Settings
                          </Link>
                        </li>
                        <li className="nav-item" onClick={() => history.push(`/program-management-center/programmes/versions/gradebook?type=open&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)}>
                          <Link
                            className={`nav-link cursor-pointer ${type === "gradebook" ? "active" : ""}`}
                            to={`/program-management-center/programmes/versions/gradebook?type=open&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`}
                          >
                            <i className="fal fa-chart-bar"></i>Gradebook
                          </Link>
                        </li>
                      </>}
                      {(((tab == "programme" || tab === "auditTrail" || tab == "shortCourse") &&
                        type == "open") ||
                        (
                          (
                            tab === "assigned-modules" ||
                            tab == "versions" ||
                            tab == "graduates" ||
                            tab === 'resources' ||
                            tab == "shortCourse-resources" ||
                            tab === 'linked_programmes' ||
                            tab == "softwareused" ||
                            (
                              tab === 'study_path' ||
                              type == "create" ||
                              type == "open"
                            ) ||
                            tab === "features-benefits" ||
                            tab == "programmeDates" ||
                            tab == "shortCourseFeatures-benefits" ||
                            tab == "shortCoursetopics" ||
                            tab == "shortCourseOutcomes" ||
                            tab == "courseDates"
                          ) && type == "table"
                        ) ||
                        (
                          tab === "features-benefits" ||
                          tab === 'shortCourseFeatures-benefits' && type == "re-arrange"
                        ) ||
                        (
                          tab == "shortCourseAuditTrail" && type == "open"
                        ) ||
                        (
                          tab == "study_path" &&
                          (
                            type == "re-arrange" || type == "create" || type == "open"
                          )
                        )
                      ) &&
                        (
                          <>
                            <li
                              className="nav-item"
                              onClick={() =>
                                history.push(
                                  ((tab == "shortCourse" || tab == "shortCourseAuditTrail") && type == "open" || (tab == "shortCoursetopics" || tab == "shortCourse-resources" || tab == "shortCourseOutcomes" || tab == "courseDates" || tab == "shortCourseFeatures-benefits") && type == "table") ? `/program-management-center/programmes/shortCourseFeatures-benefits/table/${id}` : `/program-management-center/programmes/features-benefits/table/${id}`
                                )
                              }
                            >
                              <Link
                                className={`nav-link ${tab == "features-benefits" || tab == "shortCourseFeatures-benefits" ? "active" : ""}`}
                                id="pills-tab4"
                                data-toggle="pill"
                                to={((tab == "shortCourse" || tab == "shortCourseAuditTrail") && type == "open" || (tab == "shortCoursetopics" || tab == "shortCourseOutcomes" || tab == "courseDates") && type == "table" || tab == "shortCourseFeatures-benefits") ? `/program-management-center/programmes/shortCourseFeatures-benefits/table/${id}` : `/program-management-center/programmes/features-benefits/table/${id}`}
                                href="#pills-tab14"
                                role="tab"
                                aria-controls="pills-tab14"
                                aria-selected="true"
                              >
                                {
                                  GlobalIconNames(
                                    "Features & Benefits",
                                    "fa-bars",
                                    "Features & Benefits"
                                  ).html
                                }
                              </Link>
                            </li>
                          </>
                        )}
                      {((((tab == "features-benefits" || tab == "graduates" || tab === 'resources' || tab == "softwareused" || tab == "versions" || tab == "assigned-modules" || tab == "study_path" || tab == "programmeDates" || tab == "linked_programmes") && type == "table") || (tab === "features-benefits" && type == "re-arrange") || ((tab == "programme" || tab == "auditTrail") && type == "open") || (tab == "study_path" && (type == "re-arrange" || type == "open" || type == "create"))) &&
                        <>
                          {detail?.EnableStudypathLinkReReg == 1 && <PermissionsGate scopes={['pmcversionview']} RenderError={() => null}>
                            <li
                              className="nav-item"
                              onClick={() => history.push(`/program-management-center/programmes/versions/table/${id}`)}
                            >
                              <Link
                                className={`nav-link ${tab == "versions" ? "active" : ""
                                  }`}
                                id="pills-tab3"
                                data-toggle="pill"
                                to={`/program-management-center/programmes/versions/table/${id}`}
                                href="#pills-tab13"
                                role="tab"
                                aria-controls="pills-tab13"
                                aria-selected="true"
                              >
                                {GlobalIconNames("Versions").html}
                              </Link>
                            </li>
                          </PermissionsGate>}

                          {(((tab == "programme" || tab === "auditTrail") &&
                            type == "open") ||
                            ((tab == "versions" || tab == "graduates" || tab === 'resources' || tab == "softwareused" || tab === 'linked_programmes' || (tab === 'study_path' || type == "create" || type == "open") || tab === "features-benefits" || tab == "programmeDates" || tab == "courseDates") && type == "table") || (tab === "features-benefits" && type == "re-arrange")) && (
                              <li
                                className="nav-item"
                                onClick={() =>
                                  history.push(
                                    (tab == "programme" || tab == "auditTrail") && type == "table"
                                      ? `/program-management-center/programmes/softwareused/table/${id}`
                                      : ((tab == "programme" || tab == "auditTrail") && type == "open") ||
                                        (((tab == "features-benefits" || tab == "versions" || tab == "programmeDates" || tab == "linked_programmes" || tab == "graduates") && type == "table"))
                                        ? `/program-management-center/programmes/softwareused/table/${id}`
                                        : `/program-management-center/programmes/softwareused/table/${id}`
                                  )
                                }>
                                <Link
                                  className={`nav-link ${tab == "programmes" || tab == "softwareused" ? "active" : ""
                                    }`}
                                  id="pills-tab8"
                                  data-toggle="pill"
                                  to={`/program-management-center/programmes/softwareused/table/${id}`}
                                  href="#pills-tab8"
                                  role="tab"
                                  aria-controls="pills-tab8"
                                  aria-selected="true"
                                >
                                  {GlobalIconNames("software").html}
                                </Link>

                              </li>
                            )}
                        </>
                      )}

                      {(((tab == "shortCourse" ||
                        tab === "shortCourseAuditTrail") &&
                        type == "open") ||
                        (tab == "courseDates" && type == "table") ||
                        (tab === "shortCourseFeatures-benefits" && type == "re-arrange") ||
                        (tab == "shortCoursetopics" && type == "table") ||
                        (tab == "shortCourseOutcomes" && type == "table") ||
                        (tab == "shortCourse-resources" && type == "table") ||
                        (tab == "shortCourseFeatures-benefits" && type == "table")) && (
                          <li
                            className="nav-item"
                            onClick={() =>
                              history.push(
                                `/program-management-center/programmes/shortCoursetopics/table/${id}`
                              )
                            }
                          >
                            <Link
                              className={`nav-link ${tab == "shortCoursetopics" ? "active" : ""
                                }`}
                              id="pills-tab1"
                              data-toggle="pill"
                              to={`/program-management-center/programmes/shortCoursetopics/table/${id}`}
                              href="#pills-tab11"
                              role="tab"
                              aria-controls="pills-tab11"
                              aria-selected="true"
                            >
                              {
                                GlobalIconNames("Topics", "fa-books", "Topics")
                                  .html
                              }
                            </Link>
                          </li>
                        )}

                      {(((tab == "shortCourse" ||
                        tab === "shortCourseAuditTrail") &&
                        type == "open") ||
                        (tab == "courseDates" && type == "table") ||
                        (tab === "shortCourseFeatures-benefits" && type == "re-arrange") ||
                        (tab == "shortCoursetopics" && type == "table") ||
                        (tab == "shortCourseOutcomes" && type == "table") ||
                        (tab == "shortCourse-resources" && type == "table") ||
                        (tab == "shortCourseFeatures-benefits" && type == "table")) && (
                          <li
                            className="nav-item"
                            onClick={() =>
                              history.push(
                                `/program-management-center/programmes/shortCourseOutcomes/table/${id}`
                              )
                            }
                          >
                            <Link
                              className={`nav-link ${tab == "shortCourseOutcomes" ? "active" : ""
                                }`}
                              id="pills-tab1"
                              data-toggle="pill"
                              to={`/program-management-center/programmes/shortCourseOutcomes/table/${id}`}
                              href="#pills-tab11"
                              role="tab"
                              aria-controls="pills-tab11"
                              aria-selected="true"
                            >
                              {
                                GlobalIconNames(
                                  "Outcomes",
                                  "fa-chart-pie-alt",
                                  "Outcomes"
                                ).html
                              }
                            </Link>
                          </li>
                        )}

                      {(
                        (
                          (tab == "programme" || tab == "auditTrail" || tab == "shortCourse") ||
                          (tab == "shortCourseAuditTrail" && type == "open") ||
                          tab === "programmeDates" ||
                          tab == "linked_programmes" ||
                          tab === "resources" ||
                          tab == "graduates" ||
                          tab == "assigned-modules" ||
                          tab == "features-benefits" ||
                          tab == "shortCourseFeatures-benefits" ||
                          tab == "shortCoursetopics" ||
                          tab == 'softwareused' ||
                          tab == "shortCourseOutcomes" ||
                          tab == "shortCourse-resources" ||
                          (tab == "versions" && type == "table")
                        ) &&
                        !(tab == "shortCourse" && type == "table") &&
                        !(tab == "programme" && type == "table") &&
                        !(tab == "auditTrail" && type == "table")
                      ) && (
                          <li
                            className="nav-item"
                            onClick={() =>
                              history.push(((tab == "shortCourse" || tab == "shortCourseAuditTrail") && type == "open" || ((tab == "shortCoursetopics" || tab == "shortCourseOutcomes" || tab == "courseDates" || tab == "shortCourseFeatures-benefits" || tab == "shortCourseFeatures-benefits" || tab == "shortCourse-resources") && type == "table")) || tab == "shortCourseFeatures-benefits" ? `/program-management-center/programmes/shortCourse-resources/table/${id}` : `/program-management-center/programmes/resources/table/${id}`)
                            }
                          >
                            <Link
                              className={`nav-link ${tab == "resources" || tab == "shortCourse-resources" ? "active" : ""}`}
                              id="pills-tab4"
                              data-toggle="pill"
                              to={((tab == "shortCourse" || tab == "shortCourseAuditTrail") && type == "open" || (tab == "shortCoursetopics" || tab == "shortCourseOutcomes" || tab == "courseDates" || tab == "shortCourseFeatures-benefits" || tab == "shortCourse-resources") && type == "table") ? `/program-management-center/programmes/shortCourse-resources/table/${id}` : `/program-management-center/programmes/resources/table/${id}`}
                              href="#pills-tab14"
                              role="tab"
                              aria-controls="pills-tab14"
                              aria-selected="true"
                            >
                              {GlobalIconNames("Resources", "fa-user", "Resources").html}
                            </Link>
                          </li>
                        )}
                      {(
                        (
                          (tab == "programme" || tab == "auditTrail") ||
                          (tab !== "shortCourseAuditTrail" && tab !== "shortCourse" && type == "open") ||
                          tab === "programmeDates" ||
                          tab == "linked_programmes" || tab === "resources" || tab == "graduates" || (tab == "versions" && type == "table") ||
                          tab == "features-benefits" || tab == "softwareused"
                        ) &&
                        !(tab == "shortCourse" && type == "open") &&
                        !(tab == "programme" && type == "table") &&
                        !(tab == "auditTrail" && type == "table") &&
                        !(tab == "versions" && type == "create")
                      ) && (
                          <li
                            className="nav-item"
                            onClick={() =>
                              history.push(`/program-management-center/programmes/linked_programmes/table/${id}`)
                            }
                          >
                            <Link
                              className={`nav-link ${tab == "linked_programmes" ? "active" : ""}`}
                              id="pills-tab4"
                              data-toggle="pill"
                              to={`/program-management-center/programmes/linked_programmes/table/${id}`}
                              href="#pills-tab14"
                              role="tab"
                              aria-controls="pills-tab14"
                              aria-selected="true"
                            >
                              {GlobalIconNames("Linked Programmes", "fa-link", "Linked Programmes").html}
                            </Link>
                          </li>
                        )}
                      {(detail?.EnableStudypathLinkReReg == 1
                        && (((tab == "programme" || tab == "auditTrail")
                          && type == "open")
                          || (((tab == "graduates"
                            || tab === "programmeDates"
                            || tab === 'resources'
                            || tab == "linked_programmes"
                            || tab == "softwareused"
                            || tab == "assigned-modules"
                            || tab == "versions"
                            || tab == "features-benefits")
                            && type == "table")
                            || (tab === "features-benefits"
                              && type == "re-arrange"))
                          && tab != "shortCourse"))
                        && <li
                          className="nav-item"
                          onClick={() =>
                            history.push(`/program-management-center/programmes/graduates/table/${id}`
                            )
                          }
                        >
                          <Link
                            className={`nav-link ${tab == "graduates" ? "active" : ""}`}
                            id="pills-tab4"
                            data-toggle="pill"
                            to="/program-management-center/programmes/graduates/table"
                            href="#pills-tab14"
                            role="tab"
                            aria-controls="pills-tab14"
                            aria-selected="true"
                          >
                            {GlobalIconNames("Graduates", "fa-graduation-cap", "Graduates").html}
                          </Link>
                        </li>
                      }

                      {!(tab == "versions" && type == "create") && <li
                        className="nav-item"
                        onClick={() =>
                          history.push(
                            (tab == "programme" || tab == "auditTrail" || tab == "shortCourse") && type == "table"
                              ? "/program-management-center/programmes/auditTrail/table"
                              : ((tab == "programme" || tab == "auditTrail") && type == "open") ||
                                (((tab == "features-benefits" || tab == "softwareused" || tab == "versions" || tab == "programmeDates" || tab == "linked_programmes" || tab == "graduates") && type == "table") || (tab == "study_path" && (type == "re-arrange" || type == "create" || type == "open" || type == "table")))
                                ? `/program-management-center/programmes/auditTrail/open/${id}`
                                : (tab == "versions" && type !== "table") ? `/program-management-center/programmes/versions/auditTrail?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`
                                  : `/program-management-center/programmes/shortCourseAuditTrail/open/${id}`
                          )
                        }
                      >
                        <Link
                          className={`nav-link ${tab == "auditTrail" || tab == "shortCourseAuditTrail" || type == "auditTrail" ? "active" : ""}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          to={
                            (tab == "programme" || tab == "auditTrail" || tab == "shortCourse") && type == "table"
                              ? "/program-management-center/programmes/auditTrail/table"
                              : ((tab == "programme" || tab == "auditTrail") && type == "open") ||
                                (((tab == "features-benefits" || tab == "softwareused" || tab == "versions" || tab == "programmeDates" || tab == "linked_programmes" || tab == "graduates") && type == "table") || (tab == "study_path" && (type == "re-arrange" || type == "create" || type == "open" || type == "table")))
                                ? `/program-management-center/programmes/auditTrail/open/${id}`
                                : (tab == "versions" && type !== "table") ? `/program-management-center/programmes/versions/auditTrail?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`
                                  : `/program-management-center/programmes/shortCourseAuditTrail/open/${queryProgrammeId ?? id}`
                          }
                          href="#pills-tab12"
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                        >
                          {GlobalIconNames("audittrail").html}
                        </Link>
                      </li>}


                    </ul>
                  )}

                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {tab == "programme" && type == "table" && <Program />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab14"
                      role="tabpanel"
                      aria-labelledby="pills-tab4"
                    >
                      {(tab == "features-benefits" && (type == "table" || type == "re-arrange")) && (
                        <FeaturesBenefits />
                      )}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {tab == "versions" && type == "assigned-modules" && queryType == "table" && (
                        <AssignedTable
                          id={programId}
                          versionData={versionData}
                        />
                      )}
                    </div>
                    {tab == "versions" && type == "table" && <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      <VersionTable
                        id={programId}
                      />
                    </div>}
                    {tab == "versions" && (type == "create" || type == "details" || type === "clone") && <div
                      className="tab-pane fade active show"
                      id="pills-tab130"
                      role="tabpanel"
                      aria-labelledby="pills-tab130"
                    >
                      <VersionPageData setRefresh={setRefresh} loading={vDataloading} setLoading={setVDataLoading} versionData={versionData} />
                    </div>}
                    {tab == "versions" && type == "study_path" && queryType == "table" && <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      <StudyPath id={programId} versionData={versionData} />
                    </div>}
                    {tab == "versions" && type == "gradeSetting" && <div className="tab-pane fade active show" id="pills-tab19" role="tabpanel" aria-labelledby="pills-tab9">
                      {<ProgrameGradeSetting versionData={versionData} />}
                    </div>}
                    {tab == "versions" && type == "gradebook" && <div className="tab-pane fade active show" id="pills-tab19" role="tabpanel" aria-labelledby="pills-tab9">
                      {<PMCGradeBook versionData={versionData} />}
                    </div>}
                    {(tab == "versions" && type == "study_path" && queryType == "re-arrange") && <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      <StudyPathRearrange id={programId} versionData={versionData} />
                    </div>}
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {(tab == "linked_programmes") && type == "table" &&
                        <LinkedProgrammes
                          detail={detail}
                          QAview={QAview}
                          id={programId}
                          isVersionEnabled={Number(detail?.EnableStudypathLinkReReg) === 1}
                        />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab8"
                      role="tabpanel"
                      aria-labelledby="pills-tab8"
                    >
                      {(tab == "softwareused") && type == "table" &&
                        <SoftwareUsed
                        />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {(tab == "resources") && type == "table" &&
                        <Resources />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {(tab == "shortCourse-resources") && type == "table" &&
                        <ShortCourseResources />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {(tab == "graduates") && type == "table" &&
                        <GraduatesTable
                          detail={detail}
                          id={programId}
                        />}
                    </div>
                    {(tab == "versions" && type == "study_path" && (queryType == "create" || queryType == "open")) && <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      <CreateStudyPath
                        detail={detail}
                        versionData={versionData}
                        id={programId}
                      />
                    </div>}
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab12"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      {tab == "programme" &&
                        (type == "open" ||
                          type == "add" ||
                          type == "duplicate") && (
                          <ProgramDetail detail={detail} setRefresh={setRefresh} setQAview={setQAview} />
                        )}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab113"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {tab == "shortCourse" && type == "table" && (
                        <ShortCourse />
                      )}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab122"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      {tab == "shortCourse" &&
                        (type == "open" ||
                          type == "add" ||
                          type == "duplicate") && (
                          <ShortCourseDetails detail={detail} />
                        )}
                    </div>

                    <div
                      className="tab-pane fade active show"
                      id="pills-tab922"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      {tab == "programmeDates" && type == "table" && (
                        <ProgrammeDate />
                      )}
                      {tab == "courseDates" && type == "table" && (
                        <CourseDates />
                      )}
                    </div>

                    {(tab == "auditTrail" || tab == "shortCourseAuditTrail" || (tab == "versions" && type == "auditTrail")) && <div
                      className="tab-pane fade active show"
                      id="pills-tab12"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      <AuditTrail />
                    </div>}
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab14"
                      role="tabpanel"
                      aria-labelledby="pills-tab4"
                    >
                      {(tab == "shortCourseFeatures-benefits" && (type == "table" || type == "re-arrange")) && (
                        <ShortCourseFeaturesBenefits />
                      )}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab13"
                      role="tabpanel"
                      aria-labelledby="pills-tab3"
                    >
                      {tab == "shortCoursetopics" && type == "table" && <ShortCourseTopics />}
                    </div>

                    <div
                      className="tab-pane fade active show"
                      id="pills-tab14"
                      role="tabpanel"
                      aria-labelledby="pills-tab4"
                    >
                      {tab == "shortCourseOutcomes" && type == "table" && <ShortCourseOutcomes />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Programs;
